import { wizardConstants } from '../constants';

export function updateStepAction(step) {
  return (dispatch) => {
    dispatch({ type: wizardConstants.WIZARD_UPDATE_STEP, step });
  };
}
